import script from "./RegisterUser.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterUser.vue?vue&type=script&setup=true&lang=js"

import "./RegisterUser.vue?vue&type=style&index=0&id=43366d23&lang=css"

const __exports__ = script;

export default __exports__